<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="section-panel-header">
        <mat-panel-title>
            <app-section-header
                [title]="sectionDescription.title"
                [description]="sectionDescription.description"
            ></app-section-header>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Organization Name</mat-label>
        <input matInput formControlName="organizationName" id="org-name" required />
        <mat-error>
            <app-invalid-field
                [field]="'organizationName'"
                [messageList]="workingRangeErrors['organizationName']"
            ></app-invalid-field>
        </mat-error>
    </mat-form-field>

    <div class="row">
        <div class="col-6">
            <mat-form-field appearance="outline" class="width-100">
                <mat-label>Contact Email</mat-label>
                <input matInput type="email" id="contact-email" formControlName="email" required />
                @if (emailControl.invalid && emailControl.hasError('email')) {
                    <mat-error>Invalid email</mat-error>
                }
                @if (emailControl.invalid && emailControl.hasError('required')) {
                    <mat-error>This field is required</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="col-6">
            <lib-phone-input
                formGroupName="contactPhone"
                [isFormEnabled]="true"
                [blackListCountryCodes]="blackListedCountryCodes"
                [countryCode]="initialCountryCode"
                [phone]="initialPhone"
            ></lib-phone-input>
        </div>
    </div>
    <h6>Working Hours</h6>
    <div formGroupName="workingScheduleForm">
        <mat-form-field appearance="outline" class="full-width mt-3">
            <mat-label>Time Zone</mat-label>
            <input matInput formControlName="timeZone" id="time-zone" />
        </mat-form-field>
        <div formArrayName="ranges">
            @for (group of ranges.controls; track group; let i = $index) {
                <div [formGroupName]="i" class="schedule-range">
                    <div formGroupName="daysRange" class="days-line">
                        <mat-form-field appearance="outline">
                            <mat-label>From</mat-label>
                            <mat-select id="from-day-{{ i }}" formControlName="from">
                                @for (day of weekDays; track day; let dayIndex = $index) {
                                    <mat-option [value]="day" id="from-day-option-{{ i }}-{{ dayIndex }}">{{
                                        day
                                    }}</mat-option>
                                }
                            </mat-select>
                            @if (
                                group.get('daysRange.from')?.hasError('required') &&
                                group.get('daysRange.from')?.touched
                            ) {
                                <mat-error> Required </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>To</mat-label>
                            <mat-select formControlName="to" id="to-day-{{ i }}">
                                @for (day of weekDays; track day; let dayIndex = $index) {
                                    <mat-option [value]="day" id="to-day-option-{{ i }}-{{ dayIndex }}">{{
                                        day
                                    }}</mat-option>
                                }
                            </mat-select>
                            @if (
                                group.get('daysRange.to')?.hasError('required') && group.get('daysRange.to')?.touched
                            ) {
                                <mat-error> Required </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="hours-line">
                        <mat-form-field appearance="outline">
                            <mat-label>Start Time</mat-label>
                            <input matInput type="time" formControlName="start" id="start-time-{{ i }}" />
                            @if (group.get('start')?.hasError('required') && group.get('start')?.touched) {
                                <mat-error> Start time is required </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>End Time</mat-label>
                            <input matInput type="time" formControlName="end" id="end-time-{{ i }}" />
                            @if (group.get('end')?.hasError('required') && group.get('end')?.touched) {
                                <mat-error> End time is required </mat-error>
                            }
                        </mat-form-field>
                        <button
                            mat-icon-button
                            color="warn"
                            id="delete-range-{{ i }}"
                            type="button"
                            class="remove-button mb-3"
                            (click)="removeRange(i)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    @if (group.hasError('invalidTimeRange') && group.touched) {
                        <mat-error> End time must be after start time </mat-error>
                    }
                </div>
            }
            @if (ranges.hasError('overlappingRanges')) {
                <mat-error class="mb-3"> One or more schedule ranges overlap in day and time. </mat-error>
            }
            <button
                mat-stroked-button
                color="primary"
                id="add-schedule-range"
                type="button"
                [disabled]="ranges.invalid"
                (click)="addRange()"
            >
                Add Schedule Range
            </button>
        </div>
    </div>
</mat-expansion-panel>
